// extracted by mini-css-extract-plugin
module.exports = {"container":"banner_container__8Z6ar","banner":"banner_banner__10GhS","banner-img":"banner_banner-img__3t9mV"};